import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, take } from 'rxjs';
import { ENVIRONMENT_CONFIG } from '../core';
import { HttpRequestError } from '../errors';
import { SurveyAnswer } from '../models';
import { logger } from '../utils';

export const EvaluationContentType = {
  confirmation: 'confirmation',
  content: 'content',
  restartButton: 'restartButton',
} as const;

export interface EvaluationContent {
  type: (typeof EvaluationContentType)[keyof typeof EvaluationContentType];
  value?: string;
}

export interface EvaluateSurveyResponse {
  id: string;
  contents?: EvaluationContent[];
}

@Injectable({ providedIn: 'root' })
export class EvaluateSurveyService {
  private http = inject(HttpClient);
  private baseUrl = `${
    inject(ENVIRONMENT_CONFIG).functionsBaseUrl
  }/cfEvaluateSurveyApi`;

  evaluateSurvey(survey: SurveyAnswer) {
    return this.http
      .post<EvaluateSurveyResponse>(this.baseUrl + '/evaluate-survey', {
        survey,
      })
      .pipe(
        catchError((error) => {
          logger.error(error?.message, error);
          throw new HttpRequestError(
            "Une erreur est survenue lors de l'enregistrement de la réponse.",
            { error }
          );
        }),
        take(1)
      );
  }
}
